import { Product, Session } from '../types';

export class GTMDataLayer {
    static async firePageView(pagePath: string, step?: string) {
        if (step) pagePath = `${pagePath}-${step}`;
        const pageUrl = `${window.location.origin}${pagePath}`;
        const event = {
            'event': 'virtual-page-view',
            'PagePath': pagePath,
            'PageUrl': pageUrl
        }
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(event);
        if (window.fbq) window.fbq('track', 'ViewContent');        
    }

    static addToCart(product: Product | undefined, session: Session | undefined) {
        if (!product || !session) return;
        const event = {
            user_id:session.userId,
            event: "add_to_cart",
            ecommerce: {
                currency: session.sourceCurrencyCode,
                value:session.netCharge,
                    items: [
                        {
                          item_name: product.name,
                          item_id: product.productId,
                          price: session.faceValue,
                          quantity: 1
                        }
                    ]
            }
        }
        if (window.dataLayer) {
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push(event);
        }
        if (window.fbq) window.fbq('track', 'AddToCart');
    }
    static checkout(product: Product | undefined, session: Session) {
        debugger;
        if (!product || !session) return;
        const event = {
          user_id:session.userId,
          event: "begin_checkout",
          ecommerce: {
              currency: session.sourceCurrencyCode,
              value:session.netCharge,
                  items: [
                      {
                        item_name: product.name,
                        item_id: product.productId,
                        price: session.faceValue,
                        quantity: 1
                      }
                  ]
          }
      };        
  
        //console.log(JSON.stringify(event));
        if (window.dataLayer) {
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push(event);
        }
        if (window.fbq) window.fbq('track', 'InitiateCheckout');
    }
    static addPaymentInfo(session: Partial<Session>, paymentMethod: string) {
        debugger;
        const event = {
          user_id:session.userId,
          event: "add_payment_info", 
          ecommerce: {
            currency: session.sourceCurrencyCode,
            value: session.netCharge,
            items: [
              {
                item_id: session.productId,
                item_name: session.productName,
                price: session.faceValue,
                quantity: 1
              }
            ]
          }
        }        
 
        //console.log(JSON.stringify(event));
        if (window.dataLayer) {
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push(event);
        }
        if (window.fbq) window.fbq('track', 'AddPaymentInfo');
    }
    static transactionComplete(receipt: any) {
        debugger;       
        const event = {
          user_id:receipt.user.userId,
          event: "purchase", 
          ecommerce: {
            transaction_id:receipt.transactionId,
            currency: receipt.sourceCurrencyCode,
            value: receipt.netCharge,
            items: [
              {
                item_id: receipt.product.productId,
                item_name: receipt.product.name,
                price: receipt.faceValue,
                quantity: 1
              }
            ]
          }
        }        

        if (window.dataLayer) {
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push(event);
        }
        if (window.fbq) window.fbq('track', 'Purchase', { currency: receipt.sourceCurrencyCode, value: receipt.netCharge });
    }

    static login(email: string | undefined) {
        if (!email) return;
        const event = {
            event: "login",
            data: {
                userInfo: {
                    //userId: "{{userId}}", // The user id
                    emailAddress: email, // The user's email address
                }
            }
        };
        if (window.dataLayer) {
            window.dataLayer.push(event);
        }
    }

    static register(email: string | undefined) {
        if (!email) return;
        const event = {
            event: "signup",
            data: {
                userInfo: {
                    //userId: "{{userId}}", // The user id
                    emailAddress: email, // The user's email address
                }
            }
        };
        if (window.dataLayer) {
            window.dataLayer.push(event);
        }
    }
}